import * as DataUtils from './DataUtils.js';

/**
 * Obtiene partidos entre dos selecciones rivales
 * @param {number} idPais - ID de la selección base
 * @param {number} idRival - ID de la selección rival
 * @param {object} filtro - Filtro opcional (ej: { oficial: true/false })
 * @returns {Promise<Array>} Lista de partidos
 */
export const GetPartidosSeleccionRival = async (idPais, idRival, filtro = null) => {
  if (!idPais || !idRival) return [];

  let url = `selecciones_pais/${idPais}/rivales/selecciones/${idRival}/partidos`;

  if (typeof filtro?.oficial === 'boolean') {
    url += `?oficial=${filtro.oficial}`;
  }

  const partidos = await DataUtils.FetchLista(url);
  return partidos;
};

/**
 * Obtiene totales de partidos entre dos selecciones rivales
 * @param {number} idPais - ID de la selección base
 * @param {number} idRival - ID de la selección rival
 * @param {object} categoria - Categoria opcional para filtrar
 * @param {object} filtro - Filtro opcional
 * @param {object} tipoInternacional - Tipo internacional opcional para filtrar
 * @returns {Promise<object>} Objeto con totalPartidos, ganados, empatados, perdidos, golesAFavor, golesEnContra
 */
export const GetTotalesSeleccionRival = async (
  idPais,
  idRival,
  categoria = null,
  filtro = null,
  tipoInternacional = null
) => {
  if (!idPais || !idRival) return null;

  let url = `selecciones_pais/${idPais}/rivales/selecciones/${idRival}/partidos/totales`;
  let separador = '?';

  if (categoria?.id) {
    url += `${separador}categoria=${categoria.id}`;
    separador = '&';
  }

  if (tipoInternacional?.id) {
    url += `${separador}tipoInternacional=${tipoInternacional.id}`;
    separador = '&';
  }

  if (typeof filtro?.oficial === 'boolean') {
    url += `${separador}oficial=${filtro.oficial}`;
  }

  const totales = await DataUtils.FetchObject(url);
  return totales;
};

export const GetSeleccionesRivales = async (idPais, categoria, tipoInternacional) => {
  if (!idPais || !categoria?.id) return [];
  let url = `selecciones_pais/${idPais}/rivales/selecciones?categoria=${categoria.id}`;
  if (tipoInternacional?.id) {
    url += `&tipoInternacional=${tipoInternacional.id}`;
  }
  return DataUtils.FetchLista(url);
};

// Maps TipoRival IDs to their URL path segment
const TIPO_RIVAL_PATH = { S: 'selecciones', C: 'clubes', E: 'equipos' };

export const GetTotalesRivales = async (idPais, tipoRivalId, categoria, tipoInternacional) => {
  const tipoPath = TIPO_RIVAL_PATH[tipoRivalId];
  if (!idPais || !tipoPath || !categoria?.id) return [];
  let url = `selecciones_pais/${idPais}/rivales/${tipoPath}/totales?categoria=${categoria.id}`;
  if (tipoInternacional?.id) {
    url += `&tipoInternacional=${tipoInternacional.id}`;
  }
  return DataUtils.FetchLista(url);
};

export const GetPartidosRival = async (
  idPais,
  tipoRivalId,
  idRival,
  categoria,
  pagina = 0,
  items = 50,
  filtro = null,
  tipoInternacional = null
) => {
  const tipoPath = TIPO_RIVAL_PATH[tipoRivalId];
  if (!idPais || !tipoPath || !idRival) return [];
  let url = `selecciones_pais/${idPais}/rivales/${tipoPath}/${idRival}/partidos?pagina=${pagina}&items=${items}`;
  if (categoria?.id) {
    url += `&categoria=${categoria.id}`;
  }
  if (tipoInternacional?.id) {
    url += `&tipoInternacional=${tipoInternacional.id}`;
  }
  if (typeof filtro?.oficial === 'boolean') {
    url += `&oficial=${filtro.oficial}`;
  } else if (filtro?.codigo) {
    url += `&tipoPartido=${filtro.codigo}`;
  }
  return DataUtils.FetchLista(url);
};

export const GetCantidadPartidosRival = async (
  idPais,
  tipoRivalId,
  idRival,
  categoria,
  filtro = null
) => {
  const tipoPath = TIPO_RIVAL_PATH[tipoRivalId];
  if (!idPais || !tipoPath || !idRival) return null;
  let url = `selecciones_pais/${idPais}/rivales/${tipoPath}/${idRival}/partidos/cantidad`;
  if (categoria?.id) {
    url += `?categoria=${categoria.id}`;
  }
  if (typeof filtro?.oficial === 'boolean') {
    url += `${categoria?.id ? '&' : '?'}oficial=${filtro.oficial}`;
  } else if (filtro?.codigo) {
    url += `${categoria?.id ? '&' : '?'}tipoPartido=${filtro.codigo}`;
  }
  return DataUtils.FetchObject(url);
};
